import { CategorySearchConfig } from '../SearchBarProps';

export const generateUrlForCategory = (
	config: CategorySearchConfig,
	searchInput: string
): string => {
	return `${config.categoryUrl}${
		config.searchTextUrlPrefix
	}${encodeURIComponent(searchInput)}${config.searchParams}`;
};

export const getAutocompleteUrl = (
	autocompleteUrl: string,
	searchText: string
): string => {
	return `${window.location.protocol}//${
		window.location.host
	}${autocompleteUrl}&term=${encodeURIComponent(searchText)}`;
};
